import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import Image from '@hfe/max-image';
import Text from '@hfe/max-text';
import './index.scss';
import { getImageUrl } from '../../../lib/utils/imageUtils';
const Recommend3 = (props) => {
    var _a;
    const week = {
        Monday: '周一',
        Tuesday: '周二',
        Wednesday: '周三',
        Thursday: '周四',
        Friday: '周五',
        Saturday: '周六',
        Sunday: '周日'
    };
    return <View className='recommend3-price-logo' onClick={() => props.jump(props.city, props.index)}>
      <Image className="recommend3-label-img" source={{
        uri: getImageUrl((_a = props === null || props === void 0 ? void 0 : props.cornerLabelImg) !== null && _a !== void 0 ? _a : '', 57, 0)
    }}/>
      <View x-if={!props.cornerLabelImg && props.cornerLabelWord} className='recommend3-label-word' style={{
        backgroundColor: props.cornerLabelBgColor,
        color: props.cornerLabelColor
    }}>
        {props.cornerLabelWord}
      </View>
      <Image className="recommend3-price-img" source={{
        uri: getImageUrl(props.city.picurl, 344, 0)
    }}/>
      <View className="recommend3-price-info">
        <View className="recommend3-left-content recommend3-theme-city">{props.city.arriveCityName}</View>
        <Text className="recommend3-right-content recommend3-price">
          ￥<Text className="recommend3-num">{props.city.price}</Text>
        </Text>
      </View>
      <View className="recommend3-price-info recommend3-font-grey">
        <View className="recommend3-left-content">
          {props.city.date.substr(5) + ' ' + week[props.city.week]}
        </View>
        <Text className="recommend3-right-content recommend3-font-blue">
          {props.city.discout > 0 ? `${props.city.discout / 10}折` : ''}
        </Text>
      </View>
      <Text className="recommend3-btn-booking">马上去抢</Text>
    </View>;
};
export default memo(Recommend3);
